<template>
  <div class="homePageContent page">        
        <div class="page-item page-item-banner">
            <div class="content">
                <div class="catetree">
                    <div class="catetree-title">
                        分类
                    </div>
                    <div class="catetree-content">
                        <ul>
                            <li v-for="(item,i) in cateTypeList" :key="'cateType_'+i">
                                <i class="icon" :style="{'background-image':'url('+item.cateIcon+')','background-size':'cover'}"></i>
                                <span v-for="(item1,j) in item.cateList" :key="'cateItem_'+j" ><a class="productCate" @click="toCate(item1.cateId)">{{item1.cateName}}</a><span v-if="j<(item.cateList.length-1)"> / </span></span> 
                            </li>                           
                        </ul>
                    </div>
                </div>
                <div class="banner">
                    <div class="banner-content">
                        <div class="banner-item">
                            <el-carousel>
                                <el-carousel-item  v-for="(item,i) in carouselConfigList" :key="'carousel_'+ i" >   
                                    <a href="#" @click="toGoodsDetail(item.productId)"><img :src="item.mediaPath"/></a>
                                </el-carousel-item>                      
                            </el-carousel>
                        </div>
                    </div>
                </div>
                <div class="userinfo">
                    <div class="userinfo-content">
                        <div class="userinfo-img">
                            <img src="http://img.static.knnnj.com/Default/71f25833-e29f-4677-a2f4-4015c1705391-2.png" />
                        </div>
                        <div class="userinfo-hello" v-if="isLogined">
                            HI！ <span v-if="member">{{member.memberName}}({{member.mobile}})</span> 你好！！
                        </div>
                        <div class="userinfo-hello" v-else>
                            HI！你好！！
                        </div>
                        <div class="userinfo-btns" v-if="!isLogined">
                            <a class="loginbtn" href="#" @click="toLogin()">登录</a>
                            <a class="registbtn" href="#" @click="toRegister()">注册</a>
                        </div>
                    </div>
                    <div class="userinfo-bottom">
                        <ul>
                            <li v-if="settings.advertInfo1&&settings.advertInfo1.advertUrl" ><a :href="settings.advertInfo1.advertLink" target="_blank"><img  :src="settings.advertInfo1.advertUrl" /></a></li>
                            <li v-if="settings.advertInfo2&&settings.advertInfo2.advertUrl" ><a :href="settings.advertInfo2.advertLink" target="_blank"><img :src="settings.advertInfo2.advertUrl" /></a></li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
        <div class="page-item" v-if="messages&&messages.length>0">
            <div class="content userMessage">                 
                    <div class="messageImage"><img src="https://file-sz.fjjykj.com.cn/Supply/sefd929e8c01c3cf214d5793d23412c75.png"></div>
                    <div class="messageContent">
                        <el-carousel height="20px" interval="5000">
                            <el-carousel-item  v-for="(item,index) in messages" :key="'carousel_'+ index" >   
                                No.{{index+1}} {{item.content}}
                            </el-carousel-item>   
                        </el-carousel>       
                    </div>
            </div>
        </div>
        <div class="page-group">
            <div class="group-content">
                <div class="page-item">
                    <div class="content">
                        <div class="title">
                            新品榜单
                            <a class="more" href="#" @click="toMore(5)">更多<i class="icon icon-more"></i></a>
                        </div>
                        <div class="tabcontent">
                            <ul>
                                <li v-for="(item,i) in newProductList" :key="'newgoods_'+i">                               
                                        <div class="productImage"><img :src="item.defaultImage" class="billboardImg" @click="toGoodsDetail(item.id)" /></div>
                                        <div class="productname" @click="toGoodsDetail(item.id)">
                                            {{item.name}}                                     
                                        </div>
                                        <div class="productprice">
                                            <span class="price">
                                                ￥{{item.settlementPrice}}
                                            </span>
                                            <span class="sales">
                                                成交{{item.sales}}件
                                            </span>
                                        </div>
                                        <span class="tag">
                                            <i :class="'icon icon-top-'+(i+1)"></i>
                                        </span>
                                        <div class="operationBtn1">
                                            <a  @click="toGoodsDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                                            <y-button text="加入购物车" @btnClick="showModal(item)" classStyle="main-btn"></y-button>
                                        </div>    
                                </li>                              
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="page-item">
                    <div class="content">
                        <div class="title">
                            热卖榜单
                            <a class="more" href="#" @click="toMore(4)">更多<i class="icon icon-more"></i></a>
                        </div>
                        <div class="tabcontent">
                            <ul>
                                <li v-for="(item,i) in salesProductList" :key="'salesgoods_'+i">                                
                                        <div class="productImage"><img :src="item.defaultImage" class="billboardImg" @click="toGoodsDetail(item.id)"/></div>
                                        <div class="productname" @click="toGoodsDetail(item.id)">
                                            {{item.name}}
                                        </div>
                                        <div class="productprice">
                                            <span class="price">
                                                ￥{{item.settlementPrice}}
                                            </span>
                                            <span class="sales">
                                                成交{{item.sales}}件
                                            </span>
                                        </div>
                                        <span class="tag">
                                            <i :class="'icon icon-top-'+(i+1)"></i>
                                        </span>
                                        <div class="operationBtn1">
                                            <a  @click="toGoodsDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                                            <y-button text="加入购物车" @btnClick="showModal(item)" classStyle="main-btn"></y-button>
                                        </div>     
                                </li>                              
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-item">
            <div class="content">
                <div class="title">
                    为你推荐
                    <span>根据您的浏览，实时为您推荐爆款商品</span>
                </div>
                <div class="tabnav">
                    <ul v-if="!isShowMoreBrand">
                        <li :class="(brandMenuIndex==0?'on':'')"  @click="brandMenu(0)">
                            热门推荐
                        </li>
                        <li :class="(brandMenuIndex==item.value?'on':'')" v-for="(item,i) in showBrandList" :key="'brand_'+i" @click="brandMenu(item.value)">
                            {{item.name}}
                        </li>                        
                    </ul>
                    <a v-if="!isShowMoreBrand" class="showmore" @click="setBrandShow(true)">展开<i class="icon icon-list" ></i></a>
                    <ul v-if="isShowMoreBrand" style="flex-wrap:wrap">
                        <li :class="(brandMenuIndex==0?'on':'')"  @click="brandMenu(0)">
                            热门推荐
                        </li>
                        <li :class="(brandMenuIndex==item.value?'on':'')" v-for="(item,i) in brandList" :key="'brand_'+i" @click="brandMenu(item.value)">
                            {{item.name}}
                        </li>                        
                    </ul>
                    <a v-if="isShowMoreBrand" class="showmore" @click="setBrandShow(false)">收缩<i class="icon icon-list1"></i></a>
                </div>
                <div class="tabcontent">
                    <ul>
                        <li v-for="(item,i) in productList" :key="'goods_'+i">                          
                                  <div class="recommendProductImage">
                                    <img class="recommendImg" :src="item.defaultImage" @click="toGoodsDetail(item.id)" />
                                    <img class="productIcon" v-for="(labelItem,labelIndex) in item.labels" v-if="labelIndex<1&&labelItem.labelIcon" :key="labelIndex" :src="labelItem.labelIcon" />
                                  </div>
                                  <div class="productname" style="height:20px;" @click="toGoodsDetail(item.id)">
                                      {{item.name}}
                                  </div>
                                 <div class="productprice">
                                    <span class="price">
                                        ￥{{item.settlementPrice}}
                                        <span class="scribe" v-if="item.settlementPrice<item.sellPrice">
                                        ￥{{item.sellPrice}}
                                    </span>
                                    </span>
                                   
                                    <span class="sales">
                                        成交{{item.sales}}件
                                     </span>
                                </div>                                
                                <div class="operationBtn">
                                <a  @click="toGoodsDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                                <y-button text="加入购物车" @btnClick="showModal(item)" classStyle="main-btn"></y-button>
                            </div>                         
                        </li>                        
                    </ul>
                </div>
            </div>
        </div> 
        <selectSpec ref="selectSpec"></selectSpec>
  </div>  
</template>
<style>
@import '../../styles/homePage.css';
</style>
<script>
   import { getProducts, getProductCateTypes, getBrands, getCarouselConfigs, getSettings, getMember, getMessages } from '@/api/homePage'
  import api from '@/api'
  import mallGoods from '@/components/mallGoods'
  import YButton from '@/components/yButton'
  import YShelf from '@/components/shelf'
  import SelectSpec from './components/SelectSpec' 
  import { mapState} from 'vuex'
  export default {
    data () {
      return {
        error: false,
        loading: true,
        searching: true,
        brandMenuIndex:0,
        timer: null,
        categorylist:[],
        brandList:[],
        isShowMoreBrand:false,
        showBrandList:[],
        cateTypeList : [],     
        productList:[],
        salesProductList:[],
        newProductList:[],
        categoryId:0,
        carouselConfigList:[],
        settings:{},
        member:{},
        messages:[],
      }
    },
    methods: {
    toLogin() {
      this.$router.push({ name: 'userLogin' })
    },
    toRegister () {
      this.$router.push({ name: 'userRegister' })
    },
    toCate(id)
    {
        this.categoryId = id;
        this.toMore(0);
    },
    toMore (type) {
      switch(type)
      {
        case 4:
        case 5:
             window.open('//' + window.location.host + '/#/billboard?sort=' + type)            
             //this.$router.push({ name: 'billboard', query:{sort:type} })
             break;
        default:
             this.$router.push({ name: 'search', query:{sort:type, parentCateId:this.categoryId} })
             break;
      }
    },
    toGoodsDetail(id)
    {        
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
    },
    showModal(item){     
        this.$refs['selectSpec'].showSelect(item)         
    },
    brandMenu(index)
    {
        if (this.brandMenuIndex === index) {
          return;
        }
        this.brandMenuIndex = index;
        this.loading=true;
        this._getSearch({brandId:this.brandMenuIndex});
    },
    setBrandShow(val)
    {
        this.isShowMoreBrand=val;
    },
    handleIconClick (ev) {
        console.log(123131)
          
      },
     
      async _getSearch (param) {      
        let params = {
            skipCount: param.skipCount || 0,
            maxResultCount: param.maxResultCount || 25,
            categoryId:0,
            brandId: param.brandId || 0,
            sortAsc: param.sortAsc || false,
            sorting: param.sorting,
            name: '',
            SearchKeyType:0
        }
        var type = param.type || 0;
        await getProducts(params).then(res=>{     
            switch(type)      
            {
                case 0://全部
                    this.productList=res.data.result.items
                    break;
                case 1://销售商品
                    this.salesProductList=res.data.result.items
                    break;
                case 2://新商品
                    this.newProductList=res.data.result.items
                    break;
            }
            
        });
        this.loading = false
        this.searching = false
       
      },
      // 默认排序
      reset () {
        this.sortType = 1
        this.sort = ''
        this.currentPage = 1
        this.loading = true
        this.sorting = ''
        this._getSearch()
      },

      clickBrand(v){
        this.brandId = v
        this._getSearch()
      },
      clickCate(v) {
        this.categoryId = v
        this._getSearch()
      },
      async _getBrands() {        
        await getBrands({}).then(res => {
         this.brandList = res.data.result.items
        for(var i=0;i<this.brandList.length&&i<10;i++)
        {
            this.showBrandList.push(this.brandList[i]);
        }
        })
      },    
      async _getProductCateTypes()
      {
        await getProductCateTypes().then(res=>{           
            this.cateTypeList = res.data.result
        })       
      },
     async _getCarouselConfigs()
      {
        await getCarouselConfigs().then(res=>{           
            this.carouselConfigList = res.data.result.items
        })
      },
      async _getSettings()
      {
         await getSettings().then(res=>{
            debugger
            this.settings = res.data.result
         })
      },
      async _getMember()
      {
         if(this.isLogined)
         {
         await getMember().then(res=>{         
            this.member = res.data.result
         })
        }
      },
      async _getMessages()
      {
         if(this.isLogined)
         {
         await getMessages().then(res=>{         
            this.messages = res.data.result
         })
        }
      }
    },
    created () {
    },
    computed: {
      ...mapState(['isLogined']),      
    },
    mounted () {
      this._getSearch({maxResultCount:50});
      this._getSearch({maxResultCount:3, sorting:'sales', type:1});
      this._getSearch({maxResultCount:3, sorting:'new',type:2});
      this._getBrands()
      this._getProductCateTypes()
      this._getCarouselConfigs()
      this._getSettings()
      this._getMember()
      this._getMessages()
    },
    components: {
      mallGoods,
      YButton,
      YShelf,
      SelectSpec
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?558be317